// apps/web/src/components/landing-v2/proofs/AudioProof.tsx
/** Theme 04 / Audio rituals — waveform + play button + meta.
 *  Reference: handoff .mm-audio. */

const BAR_COUNT = 28
const PLAYED_COUNT = 11

export function AudioProof() {
  return (
    <div className="absolute inset-0 flex flex-col p-5">
      <span className="inline-flex w-fit items-center rounded-pill border border-astral-violet/30 bg-astral-violet/[0.16] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-astral-violet-light">
        Drop-in audio
      </span>
      <h4
        className="mt-1.5 font-display text-text-primary"
        style={{ fontSize: '0.95rem' }}
      >
        A nine-minute breath before bed.
      </h4>

      {/* Waveform */}
      <div
        className="mt-2.5 grid items-center gap-[2px]"
        style={{
          gridTemplateColumns: `repeat(${BAR_COUNT}, 1fr)`,
          height: '28px',
        }}
      >
        {Array.from({ length: BAR_COUNT }).map((_, i) => {
          const played = i < PLAYED_COUNT
          const mod = i % 3
          const heightPct = mod === 0 ? '70%' : mod === 1 ? '40%' : '95%'
          return (
            <span
              key={i}
              className={played ? '' : 'landing-v2-wave-bar'}
              style={{
                width: '100%',
                height: heightPct,
                borderRadius: '2px',
                background: played
                  ? 'var(--color-astral-violet-light)'
                  : 'color-mix(in oklab, var(--color-astral-violet) 35%, transparent)',
                animationDelay: played ? undefined : `${i * 80}ms`,
              }}
            />
          )
        })}
      </div>

      {/* Player */}
      <div
        className="mt-auto grid items-center gap-3 rounded-xl border p-3.5"
        style={{
          background:
            'radial-gradient(ellipse at top, color-mix(in oklab, var(--color-astral-violet) 14%, transparent), transparent 65%), color-mix(in oklab, var(--color-cosmic-card) 70%, transparent)',
          borderColor: 'color-mix(in oklab, var(--color-astral-violet) 24%, transparent)',
          gridTemplateColumns: '44px 1fr',
        }}
      >
        <span
          className="inline-flex h-11 w-11 items-center justify-center rounded-full font-display text-accent-contrast"
          style={{
            background: 'var(--color-astral-violet)',
            boxShadow: '0 0 16px color-mix(in oklab, var(--color-astral-violet) 50%, transparent)',
            fontSize: '1.1rem',
          }}
          aria-hidden
        >
          ▶
        </span>
        <div className="min-w-0">
          <div
            className="font-display italic text-text-primary"
            style={{ fontSize: '0.9rem', lineHeight: 1.15 }}
          >
            Inhale, hold, release.
          </div>
          <div
            className="mt-1 flex items-center gap-2.5 text-[10px] uppercase text-text-muted"
            style={{ letterSpacing: '0.16em' }}
          >
            <span>9 min</span>
            <span
              className="inline-block h-[3px] w-[3px] rounded-full"
              style={{ background: 'var(--color-text-muted)' }}
            />
            <span>By a breathwork teacher</span>
          </div>
        </div>
      </div>
    </div>
  )
}
